import get from 'lodash/get';

const getIndicesForMatchingReplies = (replyitem, attachments) => {
  const indices = [];
  let selectedPayload = get(replyitem, 'postback.payload');
  if (!selectedPayload) {
    selectedPayload = get(replyitem, 'reply.postback.payload');
  }
  if (selectedPayload) {
    const matcher = replyToMatch => {
      const key = replyToMatch.message_type;
      const selectionReply = get(replyToMatch, `[${key}].selection.reply`);
      const reply = key === 'reply' ? replyToMatch[key] : selectionReply;
      return reply ? reply.postback.payload === selectedPayload : -1;
    };
    const index = attachments.findIndex(matcher);
    // Don't use it if we did not find anything, accept anything more than -1.
    if (index >= 0) {
      indices.push(index);
    }
  }
  return indices;
};

export { getIndicesForMatchingReplies }; // eslint-disable-line
